export default "__VITE_ASSET__CsFe5hKz__"